{
  "role": {
    "SALES": "Salesperson",
    "TECHNICIAN": "Technician"
  },
  "roleHint": {
    "SALES": "Earned on documents the user is the salesperson of.",
    "TECHNICIAN": "Earned on invoices for service work the user led (shared between the technicians)."
  },
  "basis": {
    "INVOICED": "As invoiced",
    "COLLECTED": "As collected"
  },
  "basisHint": {
    "INVOICED": "Earned when the invoice is posted; a credit note or a void takes it back.",
    "COLLECTED": "Earned as the customer pays the invoice; an unpaid or bounced payment takes it back."
  },
  "amountBase": {
    "NET_SALES": "Net sales",
    "GROSS_PROFIT": "Gross profit"
  },
  "amountBaseHint": {
    "NET_SALES": "A percentage of the sale after discount, before VAT.",
    "GROSS_PROFIT": "A percentage of the sale less its cost."
  },
  "tierMode": {
    "WHOLE": "Whole month at the tier reached",
    "MARGINAL": "Each slice at its own tier"
  },
  "tierModeHint": {
    "WHOLE": "Once the month reaches a tier, all of it is paid at that tier’s rate.",
    "MARGINAL": "Each slice of the month is paid at its own tier’s rate, like tax brackets."
  },
  "productType": {
    "GOODS": "Goods",
    "SERVICE": "Services"
  },
  "runStatus": {
    "DRAFT": "Draft",
    "CALCULATED": "Calculated",
    "APPROVED": "Approved",
    "REVERSED": "Reversed",
    "CANCELLED": "Cancelled"
  },
  "statementStatus": {
    "CALCULATED": "Calculated",
    "APPROVED": "Approved",
    "PAID": "Paid",
    "CARRIED": "Carried"
  },
  "lineKind": {
    "INVOICE": "Invoice",
    "DEBIT_NOTE": "Debit note",
    "CREDIT_NOTE": "Credit note",
    "COLLECTION": "Collection",
    "REVERSAL": "Reversal",
    "ADJUSTMENT": "Adjustment"
  },
  "plans": {
    "title": "Commission plans",
    "subtitle": "Who earns commission, on what and at what rates",
    "new": "New plan",
    "active": "Active",
    "inactive": "Off",
    "tiered_one": "{{n}} tier",
    "tiered_other": "{{n}} tiers",
    "fields": {
      "name": "Plan",
      "role": "Earner",
      "terms": "Terms",
      "rate": "Rate",
      "members": "Members",
      "status": "Status"
    },
    "empty": {
      "title": "No commission plans yet",
      "body": "Create a plan, then add the salespeople or technicians it pays."
    }
  },
  "plan": {
    "title": "Commission plan",
    "newTitle": "New commission plan",
    "newSubtitle": "The terms first; members are added once it is saved",
    "readOnly": "You can read this plan; changing it needs the commission plans permission.",
    "roleLocked": "The earner cannot change while the plan has members.",
    "rateHint": "Lines no specific rate covers are paid at this rate (tiers replace it).",
    "activeHint": "Off: its members earn nothing from the next calculation; approved months stay.",
    "tiersHint": "Optional: the month’s total sets the rate. The first tier starts at 0.",
    "ratesHint": "Optional: a rate for goods or services, a category (and its subcategories), or both.",
    "noRates": "No specific rates: every line is paid at the plan’s rate.",
    "anyType": "Any type",
    "anyCategory": "Any category",
    "categorySearch": "Search categories",
    "categoryEmpty": "No category found",
    "addTier": "Add tier",
    "removeTier": "Remove tier",
    "addRate": "Add rate",
    "removeRate": "Remove rate",
    "save": "Save plan",
    "create": "Create plan",
    "saved": "Plan saved",
    "created": "Plan created",
    "sections": {
      "terms": "Terms",
      "tiers": "Monthly tiers",
      "rates": "Rates by product"
    },
    "tabs": {
      "label": "Commission plan",
      "plan": "Plan",
      "members": "Members"
    },
    "fields": {
      "nameEn": "Name in English",
      "nameAr": "Name in Arabic",
      "role": "Who earns",
      "basis": "When it is earned",
      "amountBase": "What it is a percentage of",
      "rate": "Default rate %",
      "active": "Active",
      "notes": "Notes",
      "tierMode": "How tiers pay",
      "fromAmount": "From a month of",
      "tierRate": "Rate %",
      "productType": "Product type",
      "category": "Category",
      "sliceRate": "Rate %"
    }
  },
  "preview": {
    "title": "Preview",
    "hint": "What a month would pay under the plan as it stands, on lines no specific rate covers.",
    "amount": "A month’s {{base}} of",
    "month": "Month’s {{base}}",
    "rate": "Rate",
    "pays": "Commission",
    "sentence": "A month of {{amount}} would pay",
    "incomplete": "Fill in the rate and tiers to see the preview."
  },
  "members": {
    "intro": "Members earn under the plan for whole months; one plan per person and role at a time.",
    "add": "Add member",
    "addTitle": "Add member",
    "editTitle": "Edit member",
    "dialogBody": "Who earns under this plan as {{role}}, from which month, and their monthly target.",
    "edit": "Edit",
    "remove": "Remove",
    "removeTitle": "Remove {{name}} from the plan?",
    "removeBody": "Only a member no statement names yet can be removed; otherwise set the last month.",
    "removed": "Member removed",
    "added": "Member added",
    "saved": "Member saved",
    "save": "Save member",
    "actionsFor": "Actions for {{name}}",
    "empty": "No members yet.",
    "open": "Open",
    "chooseMonth": "Choose a month",
    "chooseUser": "Choose a person",
    "monthOf": "Month of {{label}}",
    "yearOf": "Year of {{label}}",
    "targetHint": "Shown as achievement on statements; never changes the rate.",
    "fields": {
      "user": "Person",
      "months": "Months",
      "from": "From",
      "to": "Until",
      "target": "Monthly target"
    }
  },
  "runs": {
    "title": "Commission runs",
    "subtitle": "One run a month, in order: calculate, approve, pay",
    "new": "New run",
    "newTitle": "New commission run",
    "newBody": "A run prices the month for every member and anyone carrying a balance.",
    "create": "Create run",
    "created": "Commission run for {{period}} created",
    "month": "Month",
    "year": "Year",
    "note": "Note",
    "fields": {
      "period": "Month",
      "status": "Status",
      "earners": "Earners",
      "earned": "Earned",
      "payable": "Payable"
    },
    "filters": {
      "status": "Status",
      "allStatuses": "All statuses",
      "year": "Year",
      "allYears": "All years"
    },
    "empty": {
      "title": "No commission runs yet",
      "body": "Create the first run for a month.",
      "filteredTitle": "No run matches the filters"
    }
  },
  "run": {
    "title": "Commission run",
    "backToList": "Back to commission runs",
    "calculated": "Calculated {{at}} by {{name}}",
    "approved": "Approved {{at}} by {{name}}",
    "journal": "Commission journal",
    "staleTitle": "The figures changed at approval",
    "staleBody": "Recalculating at approval gave other figures; they are saved. Review the statements, then approve again.",
    "CANCELLED": "Cancelled on {{date}}",
    "REVERSED": "Reversed on {{date}}: the commission journal was reversed",
    "totals": "Run totals"
  },
  "totals": {
    "earners": "Earners",
    "earned": "Earned",
    "payable": "Payable",
    "paid": "Paid · unpaid",
    "counts": "{{paid}} · {{unpaid}}",
    "carried": "{{n}} carried to next month"
  },
  "actions": {
    "calculate": "Calculate",
    "recalculate": "Calculate again",
    "approve": "Approve",
    "cancel": "Cancel run",
    "reverse": "Reverse"
  },
  "calculate": {
    "running": "Calculating…",
    "toast": "Commission for {{period}} calculated"
  },
  "approve": {
    "title": "Approve the commission for {{period}}?",
    "body": "Approving locks the run and posts the commission journal; positive statements become payable.",
    "confirm": "Approve and post",
    "toast": "Commission for {{period}} approved"
  },
  "reverse": {
    "title": "Reverse the commission for {{period}}",
    "body": "The commission journal is reversed and the month can be run again. Only the latest run, while nothing of it is paid.",
    "reason": "Reason",
    "confirm": "Reverse run",
    "toast": "Commission for {{period}} reversed"
  },
  "cancel": {
    "title": "Cancel the commission run for {{period}}",
    "body": "Its statements and adjustments are removed; the month can be run again.",
    "reason": "Reason",
    "confirm": "Cancel run",
    "toast": "Commission run for {{period}} cancelled"
  },
  "statements": {
    "title": "Statements",
    "carryOnly": "Balance carried only",
    "ofTarget": "of",
    "empty": "No statements in this run.",
    "notCalculated": "Not calculated yet",
    "notCalculatedBody": "Calculate the run to make its statements.",
    "fields": {
      "earner": "Earner",
      "role": "Role · plan",
      "base": "Base",
      "achievement": "Achievement",
      "earned": "Earned",
      "carriedIn": "Carried in",
      "payable": "Payable",
      "status": "Status"
    }
  },
  "adjustments": {
    "title": "Adjustments",
    "hint": "Manual lines kept when the run is calculated again",
    "add": "Add adjustment",
    "addTitle": "Add adjustment",
    "addBody": "A one-off amount for one earner and role, with the reason; negative to take back.",
    "added": "Adjustment added",
    "delete": "Delete",
    "deleteTitle": "Delete this adjustment?",
    "deleteBody": "It leaves the run at the next calculation.",
    "deleted": "Adjustment deleted",
    "empty": "No adjustments.",
    "amountHint": "Signed: a minus takes commission back.",
    "fields": {
      "user": "Person",
      "role": "Role",
      "amount": "Amount",
      "reason": "Reason"
    }
  },
  "statement": {
    "title": "Commission statement",
    "back": "Back to the {{period}} run",
    "period": "Month",
    "dates": "Period",
    "earner": "Earner",
    "plan": "Plan",
    "tierRate": "Month’s tier rate",
    "target": "Monthly target",
    "lines": "Lines",
    "noLines": "No lines this month.",
    "totals": "Statement totals",
    "base": "Month’s base",
    "earned": "Earned",
    "carriedIn": "Carried in",
    "payable": "Payable",
    "footer": "Amounts in Omani rials (<rial/>).",
    "paidDirect": "Paid on {{date}}",
    "paidByPayroll": "Paid by payroll run {{number}}",
    "heldByPayroll": "Held by payroll run {{number}}",
    "carried": "Carried to next month",
    "unpaid": "Not paid yet"
  },
  "lines": {
    "document": "Document",
    "slice": "Product",
    "current": "Worth now",
    "countedBefore": "Counted before",
    "base": "Change",
    "rate": "Rate",
    "amount": "Amount",
    "fixed": "Reversal at the rate once paid"
  },
  "pay": {
    "action": "Pay",
    "title": "Pay commission",
    "body": "Pay {{name}}’s approved commission from a cash or bank account. The payment journal is posted.",
    "amount": "Amount:",
    "paidOn": "Paid on",
    "account": "Paid from",
    "accountHint": "The cash or bank account the commission is paid from.",
    "chooseAccount": "Choose an account",
    "loadingAccounts": "Loading accounts…",
    "reference": "Reference",
    "confirm": "Record payment",
    "toast": "Commission paid"
  },
  "mine": {
    "title": "My commission",
    "subtitle": "Your statements of approved months",
    "back": "Back to my commission",
    "fields": {
      "period": "Month",
      "role": "Role · plan"
    },
    "empty": {
      "title": "No commission yet",
      "body": "Your statements appear here once a month you earned in is approved."
    }
  },
  "form": {
    "fix": "Some fields need attention.",
    "notSaved": "Not saved",
    "conflict": "Someone else changed this plan meanwhile. Reload the page to see their version."
  },
  "validation": {
    "percent": "Enter a percentage with up to 4 decimals",
    "atMost100": "At most 100",
    "notNegative": "Cannot be negative",
    "typeOrCategory": "Choose a product type or a category",
    "firstTier": "The first tier starts at 0",
    "tierOrder": "Must come after the tier before",
    "listedTwice": "Listed twice",
    "monthStart": "Choose the first day of a month",
    "monthEnd": "Choose the last day of a month",
    "positive": "Must be more than zero",
    "endBeforeStart": "Ends before it starts",
    "notZero": "Cannot be zero"
  },
  "errors": {
    "COMMISSION_PERIOD_TAKEN": "This month already has a commission run.",
    "COMMISSION_RUN_STATUS": "This cannot be done in the run’s current status. Reload the page to see it.",
    "COMMISSION_NOT_CALCULATED": "Calculate the run before approving it.",
    "COMMISSION_STALE": "Recalculated at approval, the figures changed; they are saved. Review them and approve again.",
    "COMMISSION_SAME_PERSON": "You calculated this run, so someone else must approve it.",
    "COMMISSION_OUT_OF_ORDER": "Months run one after another: an earlier month is open or missing, or a later one is approved.",
    "COMMISSION_MEMBER_OVERLAP": "This person is already on a plan of this role for part of these months.",
    "COMMISSION_MEMBER_IN_USE": "A statement already names this member: set their last month instead of removing them.",
    "COMMISSION_PLAN_NAME_TAKEN": "Another plan has this name.",
    "COMMISSION_IN_PAYROLL": "An open payroll run holds this statement: it will be paid on that payslip.",
    "COMMISSION_NOT_REVERSIBLE": "Only the latest approved run can be reversed, while nothing of it is paid or held by payroll.",
    "SALESPERSON_INVALID": "Choose an active user.",
    "TREASURY_ACCOUNT_INVALID": "Choose an active cash or bank account to pay from."
  }
}
